<template>
  <div>
    <!-- 富文本組件 -->

    <quill-editor
      class="editor ql-editor"
      v-model="content"
      ref="quillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"
    ></quill-editor>
    <material-select
      :type="1"
      @selected="handleSelectedImage"
      v-show="false"
      class="select-img"
    />
  </div>
</template>

<script>
// 工具欄配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜體 下劃線 刪除線
  ["blockquote", "code-block"], // 引用  代碼塊
  [{ list: "ordered" }, { list: "bullet" }], // 有序、無序列表
  [{ indent: "-1" }, { indent: "+1" }], // 縮進
  [{ size: ["small", false, "large", "huge"] }], // 字體大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 標題
  [{ color: [] }, { background: [] }], // 字體顏色、字體背景顏色
  [{ align: [] }], // 對齊方式
  ["clean"], // 清除文本格式
  ["link", "image"], // 鏈接、圖片、視頻
];
// import Quill from 'quill';
import { Quill, quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import MaterialSelect from "@/components/MaterialSelect";
import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageResize", ImageResize);
export default {
  props: {
    /* 編輯器的內容 */
    value: {
      type: String,
    },
    /* 圖片大小 */
    maxSize: {
      type: Number,
      default: 4000, //kb
    },
  },
  components: { quillEditor, MaterialSelect, ImageResize, Quill },
  data() {
    return {
      content: this.value,
      editorOption: {
        // placeholder: "",
        theme: "snow", // or 'bubble'
        placeholder: this.$t("common.inputContent"),
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function (value) {
                if (value) {
                  let imgBtnEle = document.querySelector(
                    ".select-img .ant-btn"
                  );
                  imgBtnEle.click();
                } else {
                  this.$refs.quillEditor.quill.format("image", false);
                }
              },
            },
          },
          imageResize: {
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white",
            },
          },
        },
      },
      imgList: [],
      limit: 99,
      isUploading: false,
    };
  },
  watch: {
    value: function () {
      this.content = this.value;
    },
  },
  methods: {
    onEditorBlur() {
      //失去焦點事件
      this.$emit("changeEditor", this.content);
      this.$emit("input", this.content);
    },
    onEditorFocus() {
      //獲得焦點事件
    },
    onEditorChange() {
      console.log("change", this.content);

      //內容改變事件
      this.$emit("changeEditor", this.content);
      this.$emit("input", this.content);
    },

    // 富文本圖片上傳前
    quillImgBefore(file) {
      let fileType = file.type;
      if (fileType === "image/jpeg" || fileType === "image/png") {
        return true;
      } else {
        this.$message.error(this.$t("message.imageType"));
        return false;
      }
    },
    handleSelectedImage(item) {
      this.quillImgSuccess({ code: 200, url: item.url });
    },

    quillImgSuccess(res, file) {
      // res為圖片服務器返回的數據
      // 獲取富文本組件實例
      let quill = this.$refs.quillEditor.quill;
      // 如果上傳成功
      if (res.code == 200) {
        // 獲取光標所在位置
        quill.setSelection({index:0, length: 1})
        let length = quill.getSelection().index;
        // 插入圖片  res.url為服務器返回的圖片地址
        quill.insertEmbed(length, "image", res.url);
        quill.formatLine(length, 1, "align", "center");
        quill.insertText(length + 1, "\n");
        // 調整光標到最後
        quill.setSelection(length + 2);
        quill.formatLine(length + 2, 2, "align", "");
        quill.focus();
      } else {
        this.$message.error(this.$t("message.imageLoadFail"));
      }
    },
    // 富文本圖片上傳失敗
    uploadError() {
      // loading動畫消失
      this.$message.error(this.$t("message.imageLoadFail"));
    },
    uploadFile(params) {},
  },
};
</script> 

<style>
.editor {
  line-height: normal !important;
  height: 400px;
  background-color: #fff;
  /* white-space: pre-wrap; */
}
.editor *{
  -webkit-user-select:text;
}
.ql-editor {
  background-color: #fff;
}
.quill-img {
  display: none;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "請輸入鏈接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "請輸入視頻地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "標題1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "標題2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "標題3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "標題4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "標題5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "標題6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "標準字體";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "襯線字體";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等寬字體";
}
</style>